import React, { ReactNode } from 'react';

import { ChatModesButtonGroup } from '~/components/chat-landing/ChatModesButtonGroup';
import { RenderFeatureFlag } from '~/components/render-feature-flag/RenderFeatureFlag';
import { ChatMode } from '~/views/alfred/use-chat-navigation/useChatNavigation';

import { AnalysisModeDropdown } from '../chat-input-fields/AnalysisModeDropdown';
import { WebSearchDropdown } from '../chat-input-fields/web-search/WebSearchDropdown';
import { UploadDropdown } from '../upload-dropdown/UploadDropdown';
import * as S from './AlfredTools.styles';

export interface AlfredToolsProps {
  isAlfredPage: boolean;
  allowedModes: ChatMode[];
  mode: ChatMode;
  isMessagePending: boolean;
  children?: ReactNode;
  showChildrenInTools: boolean;
  uploadDropdownRef: React.RefObject<HTMLDivElement | null>;
  analysisModeDropdownRef: React.RefObject<HTMLDivElement | null>;
  webSearchDropdownRef: React.RefObject<HTMLDivElement | null>;
}

export const AlfredTools = ({
  isAlfredPage,
  allowedModes,
  mode,
  isMessagePending,
  children,
  showChildrenInTools,
  uploadDropdownRef,
  analysisModeDropdownRef,
  webSearchDropdownRef,
}: AlfredToolsProps) => {
  return (
    <S.AlfredTools>
      <S.ToolsWrapper>
        {isAlfredPage && (
          <RenderFeatureFlag requiredFlag={'alfred_user_upload'}>
            <UploadDropdown contentRef={uploadDropdownRef} />
          </RenderFeatureFlag>
        )}
        <S.LeftTools>
          {!isAlfredPage && allowedModes.length > 1 && (
            <ChatModesButtonGroup compactMode variant="secondary" />
          )}
          {mode === 'research' && (
            <S.ResearchDropdowns>
              <AnalysisModeDropdown
                contentRef={analysisModeDropdownRef}
                isMessagePending={isMessagePending}
              />
              <RenderFeatureFlag requiredFlag={'alfred_trusted_sources'}>
                <S.ResearchDropdownsDivider>
                  <WebSearchDropdown contentRef={webSearchDropdownRef} />
                </S.ResearchDropdownsDivider>
              </RenderFeatureFlag>
            </S.ResearchDropdowns>
          )}
        </S.LeftTools>
      </S.ToolsWrapper>
      {showChildrenInTools && children}
    </S.AlfredTools>
  );
};
